module.exports = __webpack_public_path__ + "static/battle06-sq-035f59cc3b52ac22ae0397e472a6353a.png";